import {React, useState, useEffect} from 'react'
import ReactSelect from 'react-select';
import styles from './MoveTimeFromProject.scss';
import calendar from '../../assets/img/calendar.svg'
import Header from '../../components/Header/Header';
import Datepicker from '../../components/Datepicker/Datepicker';
import { Helmet } from 'react-helmet';

export const projectExport = [
    { label: "CP" },
    { label: "STADA" },
    { label: "Present Star" },
    { label: "Эконика" }
]

export const projectImport = [
    { label: "CP" },
    { label: "STADA" },
    { label: "Present Star" },
    { label: "Эконика" }
]

const MoveTimeFromProject = ({changeTheme, themeBlack}) => {
  return (
    <div>
        <Helmet>
          <title>Перенос времени из проекта в проект</title>
        </Helmet>
        <div className="content content-move-time-from-project">
            <div className="container">
                <h1>Перенос времени из проекта в проект</h1>
                <form action="">
                    <div className="content-form-items">
                        <div className="content-form-item">
                            <div className="content-form-item-desc">
                                <label htmlFor="">Проект экспорта:</label>
                                <span>Откуда забираем время</span>

                                <div className="content-select">
                                    <ReactSelect options={projectExport} className="react-select-container" classNamePrefix="react-select" placeholder='Введите имя' />
                                </div>

                                {/* <ReactSelect options={projectExport} className="custom-select" placeholder='Укажите проект' /> */}

                                <div className="date-block date-start-move-time">
                                    <img src={calendar} alt="" />
                                    <div className="title">Дата начала</div>
                                    <Datepicker />
                                </div>
                            </div>
                            <div className="move-time-btns">
                                <a href="#" className="btn-white">Перенести время</a>
                                <label className='label-checkbox'>
                                    <b>Тестовый запуск</b>
                                    <input type="checkbox" />
                                    <span></span>
                                </label>
                            </div>
                        </div>

                        <div className="content-form-item">
                            <div className="content-form-item-desc">
                                <label htmlFor="">Проект импорта:</label>
                                <span>Куда переносим время</span>
                                
                                <div className="content-select">
                                    <ReactSelect options={projectExport} className="react-select-container" classNamePrefix="react-select" placeholder='Введите имя' />
                                </div>

                                <div className="date-block date-start-move-time">
                                <img src={calendar} alt="" />
                                    <div className="title">Дата окончания</div>
                                    <Datepicker />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}

export default MoveTimeFromProject